import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

import { StyledStaffLines } from "../../../../components/Nav/StaffLines";
import { MenuElement } from "../common-style";

export const StyledNavLeft = styled.div`
    transition: transform 400ms;
    display: flex;
`;

export const MenuItem = styled(Link)`
    ${MenuElement}
    margin-right: 12px;
`;

export const Logo = styled.div`
    margin-right: 20px;
    color: ${p => p.theme.c.snow};
    display: flex;
    align-items: center;
    position: relative;
    transition: 400ms;

    ${p =>
        p.theme.xs(css`
            margin-right: 0;
        `)}
    a {
        display: block;

        svg {
            display: block;
            fill: ${p => p.theme.c.snow};
        }
    }
`;

export const StyledStaffLinesLeft = styled.div`
    ${StyledStaffLines}
`;